import React, { Component } from 'react';
import './Svg.scss';
import './Icon.scss';

export default class PlusOneIcon extends Component {
    render () {
        const { className, colorIndex, size } = this.props;
        let colorClass = 'color--' + colorIndex;
        let sizeClass = 'size--' + size;
        let finalClassName = "Icon " + className + " " + sizeClass + " " + colorClass;

        let label = this.props.label ? this.props.label : "+1";
        return (
            <svg className={finalClassName} version="1.1" viewBox="0 0 32 32" width="24px" height="24px" role="img">
                <g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M13 6.20789C13 5.20352 12.0581 4.46025 11.1271 4.83695C7.86664 6.15608 5.26327 8.75945 3.94414 12.0199C3.56744 12.9509 4.31071 13.8928 5.31509 13.8928C5.99512 13.8928 6.58527 13.4457 6.8622 12.8246C7.86654 10.5721 9.6793 8.75935 11.9318 7.75501C12.5529 7.47808 13 6.88793 13 6.20789ZM20.0682 7.75501C19.4471 7.47808 19 6.88793 19 6.20789C19 5.20352 19.9419 4.46025 20.8729 4.83694C24.1334 6.15608 26.7367 8.75945 28.0559 12.0199C28.4326 12.9509 27.6893 13.8928 26.6849 13.8928C26.0049 13.8928 25.4147 13.4457 25.1378 12.8246C24.1335 10.5721 22.3207 8.75935 20.0682 7.75501ZM19 27.5777C19 26.8977 19.4471 26.3075 20.0682 26.0306C22.3207 25.0263 24.1335 23.2135 25.1378 20.961C25.4147 20.3399 26.0049 19.8928 26.6849 19.8928C27.6893 19.8928 28.4326 20.8347 28.0559 21.7658C26.7367 25.0262 24.1334 27.6295 20.8729 28.9487C19.9419 29.3254 19 28.5821 19 27.5777ZM5.31509 19.8928C5.99512 19.8928 6.58527 20.3399 6.8622 20.961C7.86654 23.2135 9.67929 25.0263 11.9318 26.0306C12.5529 26.3075 13 26.8977 13 27.5777C13 28.5821 12.0581 29.3254 11.1271 28.9487C7.86664 27.6295 5.26327 25.0262 3.94414 21.7658C3.56744 20.8347 4.31071 19.8928 5.31509 19.8928Z"/>
                    <text x="8" y="21" className="plusOneIconLabel">{label}</text>
                </g>
            </svg>);
    }
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Icon/PlusOne.js